﻿angular.module('app.financeiro').factory('retornoBancoFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'RetornoBanco';

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _list = function (search, options, dataInicio, dataTermino) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listBaixaManual = function (search, options, codigoParamBanco, dataInicio, dataTermino, tipo) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoParamBanco", "value": codigoParamBanco });
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Tipo", "value": tipo });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaManual', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _baixaManual = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/BaixaManual', dto);
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _findBoletoRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindBoletoRecord', dto);
    };

    var _listNotificacoesBoleto = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListNotificacoesBoleto', dto);
    };

    var _reprocessaNotificacao = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprocessaNotificacao', dto);
    };

    var _listRetornoBoletoCNAB = function (search, codigo, situacaoFila, options) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        dto.parms.push({ "name": "SituacaoFila", "value": situacaoFila });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListRetornoBoletoCNAB', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _reprocessarDetalheRetornoCNAB = function (codigo) {
        var dto = {};
        dto.id = codigo;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprocessarDetalheRetornoCNAB', dto);
    };

    var _listBaixaAutomatica = function (search, options, dataInicio, dataTermino, situacao, numeroProposta) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });
        dto.parms.push({ "name": "NumeroProposta", "value": numeroProposta });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaAutomatica', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listBaixaAutomaticaDetalhes = function (codigo, options, search) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        dto.parms.push({ "name": "Search", "value": search });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaAutomaticaDetalhes', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _listBaixaTituloAutomaticaResumo = function (codigo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListBaixaTituloAutomaticaResumo', dto);
    };

    var _reprocessarBaixaAutomatica = function (codigo) {
        var dto = {};
        dto.id = codigo;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprocessarBaixaAutomatica', dto);
    };

    var _aprovarArquivoBaixaAutomatica = function (aprovar, codigo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "Codigo", "value": codigo });
        dto.parms.push({ "name": "Aprovar", "value": aprovar });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AprovarArquivoBaixaAutomatica', dto);
    }

    var factory = {};

    factory.addNew = _addNew;
    factory.list = _list;
    factory.findRecord = _findRecord;
    factory.listBaixaManual = _listBaixaManual;
    factory.baixaManual = _baixaManual;
    factory.findBoletoRecord = _findBoletoRecord;
    factory.listNotificacoesBoleto = _listNotificacoesBoleto;
    factory.reprocessaNotificacao = _reprocessaNotificacao;
    factory.listRetornoBoletoCNAB = _listRetornoBoletoCNAB;
    factory.reprocessarDetalheRetornoCNAB = _reprocessarDetalheRetornoCNAB;
    factory.listBaixaAutomatica = _listBaixaAutomatica;
    factory.listBaixaAutomaticaDetalhes = _listBaixaAutomaticaDetalhes;
    factory.reprocessarBaixaAutomatica = _reprocessarBaixaAutomatica;
    factory.listBaixaTituloAutomaticaResumo = _listBaixaTituloAutomaticaResumo;
    factory.aprovarArquivoBaixaAutomatica = _aprovarArquivoBaixaAutomatica;

    return factory;

}]);
